import { type FC } from 'react';
import Spinner from 'components/Spinner';
import { useReinstatementCheck } from 'hooks/useReinstatementCheck';
import styles from './Loading.module.scss';

interface LoadingProps {}

const Loading: FC<LoadingProps> = () => {
  const { isReinstatement } = useReinstatementCheck();

  const loadingText = isReinstatement
    ? 'Reactivation in progress...'
    : 'Application in progress...';

  return (
    <p className={styles.wrapper} aria-atomic="true">
      <Spinner />
      {loadingText}
    </p>
  );
};

export default Loading;
